export default "__VITE_ASSET__BHfgZ4yN__"